import {
  CHECK_IF_PROMO_CONFIGURED_REQUEST,
  CHECK_IF_PROMO_CONFIGURED_SUCCESS,
  CHECK_IF_PROMO_CONFIGURED_FAILURE
} from './actionTypes';

export const checkIfPromoConfigured = {
  request: (payload) => ({ type: CHECK_IF_PROMO_CONFIGURED_REQUEST, payload }),
  success: (data) => ({ type: CHECK_IF_PROMO_CONFIGURED_SUCCESS, data }),
  failure: (error) => ({ type: CHECK_IF_PROMO_CONFIGURED_FAILURE, error })
};
